var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{class:_vm.className,attrs:{"value":_vm.searchValue,"append-icon":"mdi-magnify","label":_vm.label,"dense":"","single-line":"","hide-details":"","placeholder":_vm.placeholder},on:{"input":function($event){return _vm.setSearchValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }